import { Fragment, memo, ReactElement } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import FormFilter from './form';
import { PublicationVM } from 'civil-status/view-models/step-form';

interface FilterPublicationProps {
  open?: boolean;
  setOpen: (value: boolean) => void;
  values?: PublicationVM;
  onChange: (key: keyof PublicationVM, value: PublicationVM[keyof PublicationVM]) => void;
  onChanges: (values: PublicationVM) => void;
  disabled?: boolean;
  onSearch: () => void;
}

const FilterPublicationComponent = ({
  open,
  values,
  setOpen,
  onChange,
  onChanges,
  disabled,
  onSearch,
}: FilterPublicationProps): ReactElement => {
  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="filter-act-content"
          id="panel-filter-act-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri di ricerca</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormFilter
            onChange={onChange}
            onChanges={onChanges}
            onSearch={onSearch}
            values={values}
            disabled={disabled}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

FilterPublicationComponent.displayName = 'Filter Publication';

const FilterPublication = memo(FilterPublicationComponent);

export default FilterPublication;
